// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
Vue.config.productionTip = false

import './components/toast/toast.css';
import Toast from './components/toast/toast.js'
Vue.use(Toast);

import DialogBox from './plugins/Dialog/Index'
Vue.use(DialogBox)

import Phone from './plugins/phone/index'
Vue.use(Phone)

import router from './router'

/* eslint-disable no-new */
var app =  new Vue({
  router,
  ...App
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js